/* eslint-disable import/no-cycle */
import { 	
	addIsSyncing, 
	removeIsSyncing, 
	clearIsSyncing,
	
	addIsUnsyncing, 
	removeIsUnsyncing, 
	clearIsUnsyncing,
	
	addIsDeleting, 
	removeIsDeleting, 
	clearIsDeleting,
	
	addIsQueuedForDelete, 
	removeIsQueuedForDelete, 
	clearIsQueuedForDelete,
	
	addIsSelected, 
	removeIsSelected, 
	clearIsSelected,

	addErrorMessages,
	removeErrorMessages,
	clearErrorMessages,
	
	clear,
 } from './actions';

 import { 
	thunkUnsyncSurveys,
	thunkSyncSurveys,
	thunkDeleteSurveys,
	thunkDeleteAllReadings,
	thunkToggleAllIsSelected,
} from './thunks';

 
export {
	addIsSyncing, 
	removeIsSyncing, 
	clearIsSyncing,
	
	addIsUnsyncing, 
	removeIsUnsyncing, 
	clearIsUnsyncing,
	
	addIsDeleting, 
	removeIsDeleting, 
	clearIsDeleting,
	
	addIsQueuedForDelete, 
	removeIsQueuedForDelete, 
	clearIsQueuedForDelete,
	
	addIsSelected, 
	removeIsSelected, 
	clearIsSelected,

	addErrorMessages,
	removeErrorMessages,
	clearErrorMessages,
	
	clear,

	thunkUnsyncSurveys,
	thunkSyncSurveys,
	thunkDeleteSurveys,
	thunkDeleteAllReadings,
	thunkToggleAllIsSelected,
};


export default {
	addIsSyncing, 
	removeIsSyncing, 
	clearIsSyncing,
	
	addIsUnsyncing, 
	removeIsUnsyncing, 
	clearIsUnsyncing,
	
	addIsDeleting, 
	removeIsDeleting, 
	clearIsDeleting,
	
	addIsQueuedForDelete, 
	removeIsQueuedForDelete, 
	clearIsQueuedForDelete,
	
	addIsSelected, 
	removeIsSelected, 
	clearIsSelected,

	addErrorMessages,
	removeErrorMessages,
	clearErrorMessages,
	
	clear,

	thunkUnsyncSurveys,
	thunkSyncSurveys,
	thunkDeleteSurveys,
	thunkDeleteAllReadings,
	thunkToggleAllIsSelected,
};
